import React, { useState, useEffect } from 'react';
import categories from '../assets/images/categories.png';
import drawing from '../assets/images/drawing.png';
import guessing from '../assets/images/guessing.png';

const screens = [
  { src: categories, alt: 'Word categories screen' },
  { src: drawing, alt: 'Drawing screen' },
  { src: guessing, alt: 'Guessing screen' },
];

function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % screens.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero" id="home">
      {/* Background gradient orbs */}
      <div className="hero-orb hero-orb-1"></div>
      <div className="hero-orb hero-orb-2"></div>
      <div className="hero-orb hero-orb-3"></div>

      {/* Floating SVG doodles */}
      <div className="doodle doodle-pencil">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round">
          <path d="M10 50 L40 20 L46 26 L16 56 Z" />
          <path d="M40 20 L44 16 L50 22 L46 26" />
          <path d="M10 50 L8 56 L16 56" />
        </svg>
      </div>

      <div className="doodle doodle-star">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" stroke="rgba(255,217,61,0.8)" strokeWidth="2" strokeLinecap="round">
          <path d="M25 5 L30 18 L44 20 L33 30 L36 44 L25 37 L14 44 L17 30 L6 20 L20 18 Z" />
        </svg>
      </div>

      <div className="doodle doodle-swirl">
        <svg width="70" height="70" viewBox="0 0 70 70" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2" strokeLinecap="round">
          <path d="M35 15 C55 15 55 35 35 35 C20 35 20 50 35 50 C50 50 55 40 50 30" />
        </svg>
      </div>

      <div className="doodle doodle-zigzag">
        <svg width="55" height="40" viewBox="0 0 55 40" fill="none" stroke="rgba(165,205,204,0.8)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="5,30 15,10 25,30 35,10 45,30 55,10" />
        </svg>
      </div>

      <div className="doodle doodle-circle">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 6">
          <circle cx="25" cy="25" r="20" />
        </svg>
      </div>

      <div className="doodle doodle-dots">
        <svg width="60" height="30" viewBox="0 0 60 30" fill="rgba(255,255,255,0.5)">
          <circle cx="8" cy="15" r="3" />
          <circle cx="24" cy="15" r="3" />
          <circle cx="40" cy="15" r="3" />
          <circle cx="56" cy="15" r="3" />
        </svg>
      </div>

      {/* Hero content */}
      <div className="hero-inner">
        {/* Availability pill */}
        <div className="hero-pill">
          <span className="hero-pill-dot">
            <span className="hero-pill-dot-inner"></span>
          </span>
          Now on iOS & Android
        </div>

        {/* Heading */}
        <h1 className="hero-heading">
          Draw. Guess.
          <br />
          <span className="hero-heading-em">Laugh Together.</span>
        </h1>

        {/* Subheading */}
        <p className="hero-desc">
          The multiplayer drawing game that brings people together. Sketch
          wildly, guess fast, and create unforgettable moments all
          in&nbsp;real&nbsp;time.
        </p>

        {/* CTA buttons */}
        <div className="hero-btns">
          <a href="#platforms" className="btn btn-hero-primary">
            <span className="btn-icon">🎮</span> Download Free
          </a>
          <a href="#how" className="btn btn-hero-secondary">
            <span className="btn-icon">▶</span> See How It Works
          </a>
        </div>

        {/* Phone mockup with rotating screenshots */}
        <div className="hero-device">
          <div className="phone">
            <div className="phone-notch"></div>
            <div className="phone-screen-carousel">
              {screens.map((screen, index) => (
                <img
                  key={index}
                  src={screen.src}
                  alt={screen.alt}
                  className={`phone-carousel-img ${index === activeIndex ? 'active' : ''}`}
                />
              ))}
            </div>
            {/* Carousel indicator dots */}
            <div className="phone-carousel-dots">
              {screens.map((_, index) => (
                <button
                  key={index}
                  className={`phone-dot ${index === activeIndex ? 'active' : ''}`}
                  onClick={() => setActiveIndex(index)}
                  aria-label={`Show screen ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="hero-stats">
          <div className="hero-stat">
            <div className="hero-stat-val">1000+</div>
            <div className="hero-stat-lbl">Words to Draw</div>
          </div>
          <div className="hero-stat-sep"></div>
          <div className="hero-stat">
            <div className="hero-stat-val">Live</div>
            <div className="hero-stat-lbl">Multiplayer</div>
          </div>
          <div className="hero-stat-sep"></div>
          <div className="hero-stat">
            <div className="hero-stat-val">Free</div>
            <div className="hero-stat-lbl">To Play</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;